var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v("Preloads bewerken")]),
      _c("w-textarea", {
        attrs: {
          label: "Preloads gescheiden door een new line",
          autofocus: "",
          height: "300",
          fancy: "",
        },
        model: {
          value: _vm.text,
          callback: function ($$v) {
            _vm.text = $$v
          },
          expression: "text",
        },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: { click: _vm.close },
            },
            [_vm._v("Cancel")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: _vm.hasError },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Bevestigen")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }